import React from 'react';
import SpaceRoleRangeForm from './SpaceRoleRangeForm';

function SpacesSettingStatisticForm(props) {
  return (
    <SpaceRoleRangeForm
      {...props}
      role="statistic"
      settingKey="statistic_role_setting"
    />
  );
}

export default SpacesSettingStatisticForm;
